import { render, staticRenderFns } from "./GoogleStep1.vue?vue&type=template&id=c73a74d8&"
import script from "./GoogleStep1.vue?vue&type=script&lang=js&"
export * from "./GoogleStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports